import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  setTheme(themeName: 'dark-theme' | 'custom-theme' | 'default') {
    if (isPlatformBrowser(this.platformId)) {
      const body = document.body;

      // Remove old theme classes
      body.classList.remove('dark-theme', 'custom-theme');

      // Add the selected theme
      if (themeName !== 'default') {
        body.classList.add(themeName);
      }

      console.log(`Theme set to: ${themeName}`);
      // Optionally persist theme in local storage
      // sessionStorage.setItem('app-theme', themeName);
    }
  }

  loadThemeOnStart() {
    // You can load saved theme here if needed
    // const savedTheme = sessionStorage.getItem('app-theme') as 'dark-theme' | 'custom-theme' | 'default';
    // this.setTheme(savedTheme || 'default');
    // this.setTheme('default');
     if (isPlatformBrowser(this.platformId)) {
      const theme: any = sessionStorage.getItem('theme');
      this.setTheme(theme);
    }
  }
}
